
import { Link } from "react-router-dom";
import PillList from "../pillList/pillList"

function OneBookDetail({ authors, book_description, book_title, cover_url, tags }) {
    return (

        <div className="one_book-detail">
            <div className="container">
                <div className="one_book-detail__left" >
                    <img className="one_book-detail__img" src={cover_url} alt={book_title} />
                </div>

                <div className="one_book-detail__right">
                    <h1 className="one_book-detail__title" ><a href="https://google.com">{book_title}</a></h1>
                    <div className="one_book-detail__author">Written by:  

                    {authors.map((author, i) => [
                            i > 0 && ", ",
                            <Link to = {`/author/${author.id}`} key={author.id}> {author.author_name} </Link>
                    ])}
                    </div>
                        <hr className= "rule" />

                        <div className= "one_book-detail__description">
                            {book_description}
                        </div>

                        <PillList tags = {tags} />
                    
                    </div> 

                </div>
            </div>
      
    )
}

export default OneBookDetail;


